import { Injectable } from "@angular/core";
import { CarrierMapper } from "./carrier.mapper";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";

@Injectable()
export class CarrierRepository extends CrudAbstractRepository {
  getMapper(): any {
    return CarrierMapper.map;
  }

  getEndpoint(): string {
    return "carrier";
  }
}
